import type { SalesforceOptionType } from "./SalesforceSelect";

export const convertGraphQLTypenamesToSimpleTypes = (typenames: (SalesforceOptionType["__typename"] | undefined)[]) => {
	return typenames.flatMap(typename => {
		switch (typename) {
			case "SalesforceAccountNode":
				return "Account";
			case "SalesforceCaseNode":
				return "Case";
			case "SalesforceContactNode":
				return "Contact";
			case "SalesforceLeadNode":
				return "Lead";
			case "SalesforceOpportunityNode":
				return "Opportunity";
			default:
				return [];
		}
	});
};

export const getInputTypeFromSalesforceType = (type: string): string | null => {
	switch (type) {
		case "string":
			return "text";
		case "double":
		case "currency":
			return "number";
		case "textarea":
			return "textarea";
		case "phone":
			return "tel";
		default:
			return null;
	}
};
